import React, { Component } from "react";
import PropTypes from "prop-types";

import range from "lodash/range";

import Picks from "./Picks";
import Player from "./Player";
import { TeamShape } from "./nfl";
import { COLOR_GREEN, FONT_LEAGUE } from "./styles";

const RANGE = range(10);

const NORM = "normal";
const WIN = "win";
const CONT_AWAY = "cont_away";
const CONT_HOME = "cont_home";

const HEADER_FONT_SIZE = 24;

const STYLE_CELL = Object.assign(
  {
    backgroundColor: "#555",
    boxSizing: "border-box",
    color: "#aaa",
    height: 51,
    width: 51,
    minHeight: 51,
    minWidth: 51,
    fontSize: 32,
    textAlign: "center",
    userSelect: "none",
  },
  FONT_LEAGUE,
);
const SELECTED_COLOR = COLOR_GREEN;
const OPACITY_FADED = { opacity: 0.5 };

function pendingValues(pending) {
  if (!pending || pending.length < 2) {
    return null;
  }
  return [pending[0], pending[1]];
}

function revInds(arr) {
  if (!arr) {
    return null;
  }
  const ret = Array(arr.length);
  arr.forEach((x, i) => {
    ret[x] = i;
  });
  return ret;
}

class SquaresTable extends Component {
  squareType(row, col, awayInds, homeInds) {
    if (!awayInds || !homeInds) {
      return NORM;
    }
    const { scoreAway, scoreHome } = this.props;
    const awayPending = pendingValues(this.props.awayPending);
    const homePending = pendingValues(this.props.homePending);
    if (awayInds[scoreAway % 10] === row && homeInds[scoreHome % 10] === col) {
      return WIN;
    } else if (
      awayPending &&
      ((awayInds[(awayPending[0] + scoreAway) % 10] === row &&
        homeInds[scoreHome % 10] === col) ||
        (awayInds[(awayPending[1] + scoreAway) % 10] === row &&
          homeInds[scoreHome % 10] === col))
    ) {
      return CONT_AWAY;
    } else if (
      homePending &&
      ((awayInds[scoreAway % 10] === row &&
        homeInds[(homePending[0] + scoreHome) % 10] === col) ||
        (awayInds[scoreAway % 10] === row &&
          homeInds[(homePending[1] + scoreHome) % 10] === col))
    ) {
      return CONT_HOME;
    }
    return NORM;
  }

  squareStyle(type, player) {
    const { away, home, selectedPlayer, fadeDisabledCells } = this.props;

    const style = STYLE_CELL;
    if (type === WIN) {
      const { scoreAway, scoreHome } = this.props;
      if (scoreAway > scoreHome) {
        return Object.assign({}, style, {
          color: away.secondaryColor,
          backgroundColor: away.primaryColor,
        });
      } else if (scoreHome > scoreAway) {
        return Object.assign({}, style, {
          color: home.secondaryColor,
          backgroundColor: home.primaryColor,
        });
      } else {
        return Object.assign({}, style, { color: "white" });
      }
    } else if (type === CONT_HOME) {
      return Object.assign({}, style, {
        color: "white",
        backgroundColor: home.secondaryColor,
      });
    } else if (type === CONT_AWAY) {
      return Object.assign({}, style, {
        color: "white",
        backgroundColor: away.secondaryColor,
      });
    } else if (selectedPlayer && player && selectedPlayer.shortName === player.shortName) {
      return Object.assign({}, style, { color: SELECTED_COLOR });
    } else if (
      fadeDisabledCells &&
      (!selectedPlayer ||
        (player && selectedPlayer && selectedPlayer.shortName !== player.shortName))
    ) {
      return Object.assign({}, style, OPACITY_FADED);
    }
    return style;
  }

  hasNums() {
    const { awayNums, homeNums } = this.props.picks;
    return !!(awayNums && homeNums);
  }

  renderRowHeads() {
    const { away, home } = this.props;
    if (!away || !home) {
      return null;
    }
    return (
      <tr
        style={{
          color: home.primaryColor,
          fontSize: HEADER_FONT_SIZE,
          textAlign: "center",
        }}
      >
        {this.hasNums() && <td />}
        {RANGE.map(col => {
          return <td key={col}>{this.props.picks.homeNums.get(col)}</td>;
        })}
      </tr>
    );
  }

  renderRow(row, awayInds, homeInds) {
    const { picks, away, home } = this.props;
    return (
      <tr key={row}>
        {this.hasNums() &&
          away &&
          home && (
            <td style={{ color: away.primaryColor, fontSize: HEADER_FONT_SIZE }}>
              {picks.awayNums.get(row)}
            </td>
          )}
        {RANGE.map(col => {
          const type = this.squareType(row, col, awayInds, homeInds);
          const clickFn =
            this.props.onClickCell && !picks.locked
              ? e => {
                  e.preventDefault();
                  this.props.onClickCell && this.props.onClickCell(row, col);
                }
              : null;

          const player = picks && picks.getPlayer(row, col);
          return (
            <td
              key={col}
              className="animateOpacity"
              onClick={clickFn}
              style={this.squareStyle(type, player)}
              title={player && player.longName}
            >
              {player && player.shortName}
            </td>
          );
        })}
      </tr>
    );
  }

  render() {
    const awayInds = revInds(this.props.picks.awayNums);
    const homeInds = revInds(this.props.picks.homeNums);
    const rows = RANGE.map(r => {
      return this.renderRow(r, awayInds, homeInds);
    });

    return (
      <table style={{ borderSpacing: 5 }}>
        <tbody>
          {this.hasNums() && this.renderRowHeads()}
          {rows}
        </tbody>
      </table>
    );
  }
}

SquaresTable.propTypes = {
  scoreAway: PropTypes.number,
  scoreHome: PropTypes.number,
  awayPending: PropTypes.array,
  homePending: PropTypes.array,

  onClickCell: PropTypes.func,
  picks: PropTypes.instanceOf(Picks),

  away: TeamShape,
  home: TeamShape,

  selectedPlayer: PropTypes.instanceOf(Player),
  fadeDisabledCells: PropTypes.boolean,
};
SquaresTable.defaultProps = {
  fadeDisabledCells: false,
};

export default SquaresTable;



// WEBPACK FOOTER //
// ./src/SquaresTable.js